import { render, staticRenderFns } from "./NewInputMoney.vue?vue&type=template&id=961c8238&scoped=true"
import script from "./NewInputMoney.vue?vue&type=script&lang=js"
export * from "./NewInputMoney.vue?vue&type=script&lang=js"
import style0 from "./NewInputMoney.vue?vue&type=style&index=0&id=961c8238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961c8238",
  null
  
)

export default component.exports